import moment from 'moment';
// eslint-disable-next-line import/no-cycle
import {
  loadTestTypes,
  loadProjects,
  addNewProject,
  loadDetailedProject,
  loadDetailedProjectForSP,
  updateServiceProviderInfo,
  updateProjectStatusBySP,
  updateProjectCredentials,
  loadProjectsForSP,
  addNewTestProject,
  loadTestCards,
  removeTestCard,
  calculateLastScanData,
  loadPanoramicData,
  initiateTestCard,
  addNewConfiguration,
  loadSubdomainsFromConfiguration,
  loadHostsFromConfiguration,
  loadCredentialsFromConfiguration,
  loadDomainsConfiguration,
  initiatePasswordSprayScan,
  initiateHijackedActionAsset,
  getPassiveRiskScoreHistory,
  loadCloudAssetsFromConfiguration,
  loadBucketAssetsFromConfiguration,
  loadServicesAssetsFromConfiguration,
  deleteConfiguration,
  getSubdomainForTld,
  getHostsForSubdomain,
  stopScan,
  retryScan,
  initiateWafActionAsset,
  loadSubdomainTagsConfiguration,
  loadDomainTagsConfiguration,
  getPortsToScore,
  getWafManualConfiguration,
  loadRowLevelCloudItem,
  getAmountOfRunningProjects,
  loadOrganizationTagsConfiguration,
  loadCloudAccountsConfiguration, loadCloudAccountsTags, getEmailsForTld, createCTCNode,
} from '@/services/repository';
import {projectStatuses, TEST_TYPES_TLDS} from '@/constants/projects';
import {
  CLEAR_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE,
  CLEAR_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS,
  SET_CLOUD_ACCOUNTS_LOADING,
  SET_CLOUD_SERVICES_LOADING,
  SET_CLOUD_SERVICES_REF_ID,
  CLEAR_CLOUD_SERVICES_REF_ID,
  SET_LOADING_PASSWORD_SPRAY,
  SET_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE,
  SET_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS,
  SET_SUCCESS_OPERATION_MESSAGE,
  SET_CLOUD_SERVICES_RUNNING_INTERVAL,
  SET_CLOUD_SERVICES_PROGRESS,
  CLEAR_CLOUD_SERVICES_PROGRESS,
  SET_RETRY_COUNTER,
} from '@/store/configuration/mutationTypes';
import { createRunMutationAction } from '@/store/utils';
import * as types from '@/store/project/actionTypes';
import {
  HOST,
  SUBDOMAIN,
  DOMAIN,
  CLOUD_ASSET,
  BUCKET_ASSET,
  SERVICES_ASSET,
  PASSWORD_SPRAY,
  CREDENTIALS,
  CONFIGURATION,
  TAGS_SUBDOMAIN, TAGS_DOMAIN,
  SECOND_LEVEL, THIRD_LEVEL, FORTH_LEVEL, TAGS_ORGANIZATION, CLOUD_ACCOUNT, TAGS_CLOUD_ACCOUNT,
} from '@/constants/configuration';
import {
  CLEAR_PROJECTS_PAGINATION_STATE,
  SET_CLOUD_ACCOUNTS_PAGINATION_STATE,
  SET_PROJECTS_PAGINATION_STATE,
  SET_SERVICES_ASSETS_PAGINATION_STATE,
} from '@/store/pagination/mutationTypes';
import {
  CLEAR_TEST_CARDS,
  SET_TEST_CARDS,
  SET_TEST_TYPES,
  SET_PROJECTS,
  SET_PROJECT,
  SET_DETAILED_PROJECT_LOADING,
  CLEAR_PROJECT,
  CLEAR_PROJECTS,
  SET_PROJECT_LIST_OPTIONS,
  SET_CONFIGURATION_SUBDOMAINS,
  SET_CONFIGURATION_HOSTS,
  SET_CONFIGURATION_DOMAINS,
  SET_TEST_CARDS_DOMAINS,
  SET_TEST_CARDS_SUBDOMAINS,
  SET_TEST_CARDS_HOSTS,
  SET_DATA_LOADING,
  SET_PROJECT_LIST_LOADING,
  SET_PANORAMIC_DATA,
  SET_RISK_SCORE_HISTORY,
  SET_CONFIGURATION_BUCKET_ASSETS,
  SET_CONFIGURATION_CLOUD_ASSETS,
  SET_CONFIGURATION_SERVICES_ASSETS,
  SET_PORTS_TO_SCORE,
  SET_SUBDOMAINS_FOR_TLD,
  SET_HOSTS_FOR_SUBDOMAIN,
  SET_LAST_CTC_NODE,
  SET_TEST_CARDS_PASSWORD_SPRAY,
  SET_ADDING_CONFIGURATION_FLAG,
  SET_TEST_CARDS_DOMAINS_LAST_SCANNED_DATE,
  SET_CONFIGURATION_CREDENTIALS,
  SET_DELETE_CONFIGURATION_LOADING,
  CLEAR_DELETE_CONFIGURATION_LOADING,
  SET_CONFIGURATION_SUBDOMAIN_TAGS,
  SET_CONFIGURATION_DOMAIN_TAGS,
  CLEAR_PORTS_TO_SCORE,
  SET_CLOUD_SERVICES_SECOND_LEVEL_ITEMS,
  SET_CLOUD_SERVICES_THIRD_LEVEL_ITEMS,
  CLEAR_CLOUD_SERVICES_SECOND_LEVEL_ITEMS,
  CLEAR_CLOUD_SERVICES_THIRD_LEVEL_ITEMS,
  SET_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS,
  SET_SERVICES_ASSETS_LIST_OPTIONS,
  CLEAR_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS,
  SET_CONFIGURATION_SERVICES_COMPLIANCE_OPTIONS,
  CLEAR_AMOUNT_OF_RUNNING_PROJECTS,
  SET_AMOUNT_OF_RUNNING_PROJECTS,
  SET_HAS_DISCOVERY_FINISHED,
  SET_CONFIGURATION_CLOUD_ACCOUNTS,
  SET_CONFIGURATION_CLOUD_ACCOUNTS_OPTIONS,
  SET_TEST_CARDS_CLOUD_ACCOUNTS,
  SET_CONFIGURATION_ORGANIZATION_TAGS,
  SET_CONFIGURATION_CLOUD_ACCOUNT_TAGS,
  SET_ADD_TAGS_INTERVAL_RUNNING,
  SET_ADD_TAGS_REF_ID,
  CLEAR_ADD_TAGS_REF_ID,
  CLEAR_PROJECTS_PROGRESS,
  SET_PROJECTS_RUNNING_INTERVAL,
  CLEAR_PROJECTS_REF_ID, SET_PROJECTS_REF_ID, SET_PROJECTS_PROGRESS, SET_EMAILS_FOR_TLD,
} from './mutationTypes';

const getConfigurationActionType = type => {
  const actionTypes = {
    [SUBDOMAIN]: types.LOAD_SUBDOMAINS_FROM_CONFIGURATION,
    [HOST]: types.LOAD_HOSTS_FROM_CONFIGURATION,
    [CREDENTIALS]: types.LOAD_CREDENTIALS_FROM_CONFIGURATION,
    [DOMAIN]: types.LOAD_DOMAINS_FROM_CONFIGURATION,
    [CLOUD_ASSET]: types.LOAD_CLOUD_ASSETS_FROM_CONFIGURATION,
    [BUCKET_ASSET]: types.LOAD_BUCKET_ASSETS_FROM_CONFIGURATION,
    [SERVICES_ASSET]: types.LOAD_SERVICES_ASSETS_FROM_CONFIGURATION,
    [TAGS_SUBDOMAIN]: types.LOAD_SUBDOMAIN_TAGS_FROM_CONFIGURATION,
    [TAGS_DOMAIN]: types.LOAD_DOMAIN_TAGS_FROM_CONFIGURATION,
    [TAGS_ORGANIZATION]: types.LOAD_ORGANIZATION_TAGS_FROM_CONFIGURATION,
    [CLOUD_ACCOUNT]: types.LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION,
    [TAGS_CLOUD_ACCOUNT]: types.LOAD_CLOUD_ACCOUNT_TAGS_FROM_CONFIGURATION,
  };

  return actionTypes[type] || actionTypes[DOMAIN];
};

const getTestCardsActionType = type => {
  const actionTypes = {
    [SUBDOMAIN]: types.LOAD_TEST_CARDS_SUBDOMAINS,
    [HOST]: types.LOAD_TEST_CARDS_HOSTS,
    [DOMAIN]: types.LOAD_TEST_CARDS_DOMAINS,
    [CLOUD_ACCOUNT]: types.LOAD_TEST_CARDS_CLOUD_ACCOUNTS,
    [PASSWORD_SPRAY]: types.LOAD_TEST_CARDS_PASSWORD_SPRAY,
  };

  return actionTypes[type] || actionTypes[HOST];
};

const getTimeWithMinuteOffset = offset => moment()
  .startOf('minute')
  .add(offset, 'minute')
  .format('HH:mm');

export default {
  async [types.LOAD_AMOUNT_OF_RUNNING_PROJECTS]({ commit }) {
    try {
      const amountOfRunningProjects = await getAmountOfRunningProjects();
      await commit(SET_AMOUNT_OF_RUNNING_PROJECTS, amountOfRunningProjects);
    } catch (e) {
      console.error(e);
      await commit(CLEAR_AMOUNT_OF_RUNNING_PROJECTS);
    }
  },
  async [types.GET_SUBDOMAINS_FOR_TLD]({ commit }, payload) {
    try {
      const subdomains = await getSubdomainForTld(payload.tld);
      await commit(SET_SUBDOMAINS_FOR_TLD, subdomains);
    } catch (e) {
      console.error(e);
      await commit(SET_SUBDOMAINS_FOR_TLD, []);
    }
  },
  async [types.GET_EMAILS_FOR_TLD]({ commit }, payload) {
    try {
      const subdomains = await getEmailsForTld(payload.tld);
      await commit(SET_EMAILS_FOR_TLD, subdomains);
    } catch (e) {
      console.error(e);
      await commit(SET_EMAILS_FOR_TLD, []);
    }
  },
  async [types.GET_HOSTS_FOR_SUBDOMAIN]({ commit }, payload) {
    try {
      const hosts = await getHostsForSubdomain(payload.tld, payload.subdomain);
      await commit(SET_HOSTS_FOR_SUBDOMAIN, hosts);
    } catch (e) {
      console.error(e);
      await commit(SET_HOSTS_FOR_SUBDOMAIN, []);
    }
  },
  async [types.CREATE_CTC_NODE]({ commit }, payload) {
    try {
      const newNode = await createCTCNode(payload);
      await commit(SET_LAST_CTC_NODE, newNode);
    } catch (e) {
      console.error(e);
      await commit(SET_LAST_CTC_NODE, {});
    }
  },
  async [types.CLEAR_LAST_CTC_NODE]({ commit }) {
    try {
      await commit(SET_LAST_CTC_NODE, {});
    } catch (e) {
      console.error(e);
    }
  },
  async [types.REMOVE_SUBDOMAINS_FOR_TLD]({ commit }) {
    try {
      await commit(SET_SUBDOMAINS_FOR_TLD, []);
    } catch (e) {
      console.error(e);
    }
  },
  async [types.REMOVE_EMAILS_FOR_TLD]({ commit }) {
    try {
      await commit(SET_EMAILS_FOR_TLD, []);
    } catch (e) {
      console.error(e);
    }
  },
  async [types.REMOVE_HOSTS_FOR_SUBDOMAIN]({ commit }) {
    try {
      await commit(SET_HOSTS_FOR_SUBDOMAIN, []);
    } catch (e) {
      console.error(e);
    }
  },
  async [types.INITIATE_PASSWORD_SPRAY_SCAN]({ commit, dispatch }, payload) {
    let result = {};
    try {
      await commit(SET_LOADING_PASSWORD_SPRAY, true);
      const payloadWithTime = {
        ...payload,
        startTime: {
          time: getTimeWithMinuteOffset(2),
          date: moment().format(),
        },
      };
      const successMessageType = payload.successMessageType || '';
      result = await initiatePasswordSprayScan(payloadWithTime);
      if (result) {
        if (result?.notValidatedDomains) {
          commit(SET_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS, result.notValidatedDomains);
        }
        if (result?.notLicensedDomains) {
          commit(SET_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE, result.notLicensedDomains);
        }
        commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
        await dispatch(types.LOAD_TEST_CARDS_PASSWORD_SPRAY);
        await dispatch(types.LOAD_AMOUNT_OF_RUNNING_PROJECTS);
      }
    } catch (e) {
      console.log(e);
      commit(CLEAR_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS);
      commit(CLEAR_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE);
    } finally {
      await commit(SET_LOADING_PASSWORD_SPRAY, false);
    }
  },
  async [types.SET_LOADING_DATA_FLAG]({ commit }, payload) {
    await commit(SET_DATA_LOADING, payload);
  },
  async [types.LOAD_SUBDOMAINS_FROM_CONFIGURATION]({ commit }) {
    try {
      const subdomains = await loadSubdomainsFromConfiguration();
      commit(SET_CONFIGURATION_SUBDOMAINS, subdomains);
    } catch (e) {
      console.log(e);
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async [types.UPDATE_DATA_LEAKS_CONFIGURATION]({}, payload) {
    try {
      await addNewConfiguration(payload);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_HOSTS_FROM_CONFIGURATION]({ commit }) {
    try {
      const hosts = await loadHostsFromConfiguration();
      commit(SET_CONFIGURATION_HOSTS, hosts);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_CREDENTIALS_FROM_CONFIGURATION]({ commit }) {
    try {
      const credentials = await loadCredentialsFromConfiguration();
      commit(SET_CONFIGURATION_CREDENTIALS, credentials);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.GET_RISK_SCORE_HISTORY]({ commit }, payload) {
    try {
      const riskScoreHistoryPerTLD = await getPassiveRiskScoreHistory(payload);
      commit(SET_RISK_SCORE_HISTORY, riskScoreHistoryPerTLD);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.CHANGE_CLOUD_ACCOUNTS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    let search = '';
    if (options.searchUpdated) {
      search = options.search;
    } else {
      search = options.search === undefined ? getters.cloudAccountsListOptions.search : options.search;
    }
    commit(SET_CONFIGURATION_CLOUD_ACCOUNTS_OPTIONS, {
      noLimit: options.noLimit || false,
      sort: options.sort || getters.cloudAccountsListOptions.sort,
      limit: options.limit || getters.cloudAccountsListOptions.limit,
      page: options.page || getters.cloudAccountsListOptions.page,
      search,
    });
    await dispatch(types.LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION, {
      noLimit: options.noLimit || false,
      sort: options.sort || getters.cloudAccountsListOptions.sort,
      limit: options.limit || getters.cloudAccountsListOptions.limit,
      page: options.page || getters.cloudAccountsListOptions.page,
      search,
      organizations: options?.organizations || getters.organizationFilter,
      turnOnLoading: options.turnOnLoading,
    });
  },
  async [types.LOAD_CLOUD_ACCOUNTS_FROM_CONFIGURATION]({ commit }, payload) {
    try {
      if (payload?.turnOnLoading) {
        await commit(SET_CLOUD_ACCOUNTS_LOADING, true);
      }
      if (payload === undefined) {
        // eslint-disable-next-line no-param-reassign
        payload = {
          noLimit: true,
        };
      }
      const accounts = await loadCloudAccountsConfiguration(payload);
      const {
        page,
        pageCount,
        count,
        total,
        items,
      } = accounts;
      commit(SET_CLOUD_ACCOUNTS_PAGINATION_STATE, {
        page,
        pageCount,
        count,
        total,
      });
      commit(SET_CONFIGURATION_CLOUD_ACCOUNTS, items);
    } catch (e) {
      console.log(e);
    } finally {
      await commit(SET_CLOUD_ACCOUNTS_LOADING, false);
    }
  },
  async [types.UPDATE_SELECTED_CLOUD_ACCOUNTS]({ commit }, payload) {
    await commit(SET_CONFIGURATION_CLOUD_ACCOUNTS, payload);
  },
  async [types.LOAD_DOMAINS_FROM_CONFIGURATION]({ commit, getters }) {
    try {
      const result = await loadDomainsConfiguration();
      const domains = result;
      commit(SET_CONFIGURATION_DOMAINS, domains);
      const hasDiscoveryFinished = {};
      Object.values(domains).forEach(tld => {
        let {validated} = tld;
        if (tld.configData === getters.domains[0]) {
          validated = true;
        }
        hasDiscoveryFinished[tld.configData] = { validated };
      });
      commit(SET_HAS_DISCOVERY_FINISHED, hasDiscoveryFinished);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_SUBDOMAIN_TAGS_FROM_CONFIGURATION]({ commit }) {
    try {
      const subdomainTags = await loadSubdomainTagsConfiguration();
      commit(SET_CONFIGURATION_SUBDOMAIN_TAGS, subdomainTags);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_ORGANIZATION_TAGS_FROM_CONFIGURATION]({ commit }) {
    try {
      const organizationTags = await loadOrganizationTagsConfiguration();
      commit(SET_CONFIGURATION_ORGANIZATION_TAGS, organizationTags);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_DOMAIN_TAGS_FROM_CONFIGURATION]({ commit }) {
    try {
      const domainTags = await loadDomainTagsConfiguration();
      commit(SET_CONFIGURATION_DOMAIN_TAGS, domainTags);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_CLOUD_ACCOUNT_TAGS_FROM_CONFIGURATION]({ commit }) {
    try {
      const cloudAccountsTags = await loadCloudAccountsTags();
      commit(SET_CONFIGURATION_CLOUD_ACCOUNT_TAGS, cloudAccountsTags);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_CLOUD_ASSETS_FROM_CONFIGURATION]({ commit }) {
    try {
      const cloudAssets = await loadCloudAssetsFromConfiguration();
      await commit(SET_CONFIGURATION_CLOUD_ASSETS, cloudAssets);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_BUCKET_ASSETS_FROM_CONFIGURATION]({ commit }) {
    try {
      const bucketAssets = await loadBucketAssetsFromConfiguration();
      await commit(SET_CONFIGURATION_BUCKET_ASSETS, bucketAssets);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.CHANGE_SERVICES_ASSETS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    let search = '';
    if (options.searchUpdated) {
      search = options.search;
    } else {
      search = options.search === undefined ? getters.servicesAssetsListOptions.search : options.search;
    }
    commit(SET_SERVICES_ASSETS_LIST_OPTIONS, {
      sort: options.sort || getters.servicesAssetsListOptions.sort,
      limit: options.limit || getters.servicesAssetsListOptions.limit,
      page: options.page || getters.servicesAssetsListOptions.page,
      search,
      complianceItems: options.complianceItems || getters.servicesAssetsListOptions.complianceItems,
      regions: options.regions || getters.servicesAssetsListOptions.regions,
    });
    await dispatch(types.LOAD_SERVICES_ASSETS_FROM_CONFIGURATION, {
      sort: options.sort,
      limit: options.limit,
      page: options.page,
      search: options.search,
      domain: options?.domain || getters.domainFilter,
      complianceItems: options.complianceItems,
      regions: options.regions,
      turnOnLoading: options.turnOnLoading,
      refId: options?.refId || '',
    });
  },
  async [types.LOAD_SERVICES_ASSETS_FROM_CONFIGURATION]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_CLOUD_SERVICES_PROGRESS);
        }
        await commit(SET_CLOUD_SERVICES_LOADING, true);
      }

      await commit(SET_CLOUD_SERVICES_RUNNING_INTERVAL, true);
      result = await loadServicesAssetsFromConfiguration({
        sort: payload.sort || getters.servicesAssetsListOptions.sort,
        limit: payload.limit || getters.servicesAssetsListOptions.limit,
        page: payload.page || getters.servicesAssetsListOptions.page,
        search: payload.search || getters.servicesAssetsListOptions.search,
        domain: payload.domain || getters.domainFilter,
        complianceItems: payload.complianceItems || getters.servicesAssetsListOptions.complianceItems,
        regions: payload.regions || getters.servicesAssetsListOptions.regions,
        refId: payload?.refId || '',
      });
      await commit(SET_CLOUD_SERVICES_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.cloudServicesRefId) {
            commit(SET_CLOUD_SERVICES_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_CLOUD_SERVICES_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_CLOUD_SERVICES_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_CLOUD_SERVICES_REF_ID);
          commit(CLEAR_CLOUD_SERVICES_PROGRESS);
          const {
            items, complianceOptions, page, pageCount, count, total,
          } = result;
          commit(SET_SERVICES_ASSETS_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            await commit(SET_CONFIGURATION_SERVICES_ASSETS, items);
          }
          if (complianceOptions) {
            await commit(SET_CONFIGURATION_SERVICES_COMPLIANCE_OPTIONS, complianceOptions);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        cloudServices: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.cloudServices > 5) {
        console.log(e);
        commit(CLEAR_CLOUD_SERVICES_REF_ID);
        commit(CLEAR_CLOUD_SERVICES_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          cloudServices: getters.retryCounter.cloudServices + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_CLOUD_SERVICES_LOADING, false);
      }
    }
  },
  async [types.LOAD_CLOUD_SERVICES_LEVEL_ITEMS]({ commit }, payload) {
    try {
      const currentItem = await loadRowLevelCloudItem(payload);
      if (currentItem) {
        if (payload.layer === SECOND_LEVEL) {
          await commit(SET_CLOUD_SERVICES_SECOND_LEVEL_ITEMS, currentItem);
        } else if (payload.layer === THIRD_LEVEL) {
          await commit(SET_CLOUD_SERVICES_THIRD_LEVEL_ITEMS, currentItem);
        } else if (payload.layer === FORTH_LEVEL) {
          await commit(SET_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS, currentItem);
        }
      }
    } catch (e) {
      console.log(e);
    }
  },
  async [types.CLEAR_CLOUD_SERVICES_LEVEL_ITEMS]({ commit }, payload) {
    try {
      if (payload.level === SECOND_LEVEL) {
        await commit(CLEAR_CLOUD_SERVICES_SECOND_LEVEL_ITEMS, payload);
      } else if (payload.level === THIRD_LEVEL) {
        await commit(CLEAR_CLOUD_SERVICES_THIRD_LEVEL_ITEMS, payload);
      } else if (payload.layer === FORTH_LEVEL) {
        await commit(CLEAR_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS);
      }
    } catch (e) {
      console.log(e);
    }
  },
  async [types.INITIATE_HIJACKED_ACTION_ASSET]({ commit, dispatch }, payload) {
    try {
      const successMessageType = payload.successMessageType || '';
      await initiateHijackedActionAsset(payload);
      commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      await dispatch(types.LOAD_SUBDOMAINS_FROM_CONFIGURATION);
    }
  },
  async [types.INITIATE_WAF_ACTION_ASSET]({ dispatch }, payload) {
    try {
      await initiateWafActionAsset(payload);
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      await dispatch(types.LOAD_SUBDOMAINS_FROM_CONFIGURATION);
    }
  },
  async [types.ADD_URL_CONFIGURATIONS]({ getters, dispatch, commit }, {
    payload,
    tld,
    configType,
    scanEmployees = true,
    successMessageType = '',
    displayMessage = true,
    timezone = null,
    runIpResolver = false,
  }) {
    const isAddingConfigurationInProgress = getters.lastAddingConfigurationActionData?.running;
    const lastAddingConfigurationActionConfigType = getters.lastAddingConfigurationActionData?.configType;
    if (!isAddingConfigurationInProgress || (isAddingConfigurationInProgress && lastAddingConfigurationActionConfigType !== configType)) {
      await commit(SET_ADDING_CONFIGURATION_FLAG, {
        running: true,
        configType,
      });
      try {
        const payloadObject = {
          data: payload,
          tld,
          configType,
          scanEmployees,
          startTime: {
            time: getTimeWithMinuteOffset(2),
            date: moment().format(),
          },
          timezone,
          successMessageType,
          runIpResolver,
        };
        if (payload && payload?.tab) {
          await commit(SET_ADD_TAGS_INTERVAL_RUNNING, true);
          const result = await addNewConfiguration(payloadObject);
          await commit(SET_ADD_TAGS_INTERVAL_RUNNING, false);
          if (result) {
            if (result?.refId) {
              if (result.refId !== getters.addTagsRefId) {
                await commit(SET_ADD_TAGS_REF_ID, result.refId);
              }
            } else {
              await commit(CLEAR_ADD_TAGS_REF_ID);
              await commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
              await dispatch(getConfigurationActionType(configType));
            }
          }
        } else {
          await addNewConfiguration(payloadObject);
          await dispatch(getConfigurationActionType(configType));
          if (displayMessage) {
            await commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
          }
        }
      } catch (e) {
        console.error(e.message);
        await commit(CLEAR_ADD_TAGS_REF_ID);
        throw e;
      } finally {
        await commit(SET_ADDING_CONFIGURATION_FLAG, {
          running: false,
          configType: null,
        });
      }
    }
  },
  async [types.DELETE_CONFIGURATION]({ dispatch, commit }, {
    payload, configType, successMessageType = '', displayMessage = true,
  }) {
    commit(SET_DELETE_CONFIGURATION_LOADING, true);
    try {
      const payloadObject = {
        data: payload,
        configType,
      };
      await deleteConfiguration(payloadObject);
      await dispatch(getConfigurationActionType(configType));
      if (displayMessage) {
        commit(SET_SUCCESS_OPERATION_MESSAGE, CONFIGURATION.SUCCESS_MESSAGES_BY_ACTION_TYPE[successMessageType]);
      }
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      commit(CLEAR_DELETE_CONFIGURATION_LOADING);
    }
  },
  async [types.LOAD_TEST_CARDS]({ dispatch }) {
    try {
      await dispatch(getTestCardsActionType(SUBDOMAIN));
      await dispatch(getTestCardsActionType(HOST));
      await dispatch(getTestCardsActionType(DOMAIN));
      await dispatch(getTestCardsActionType(CLOUD_ACCOUNT));
      await dispatch(getTestCardsActionType(PASSWORD_SPRAY));
    } catch (e) {
      console.error(e);
    }
  },
  async [types.INITIATE_TEST_CARD]({ commit, dispatch }, payload) {
    try {
      commit(SET_SUCCESS_OPERATION_MESSAGE, '');
      await initiateTestCard(payload);
      dispatch(types.LOAD_TEST_CARDS);
      commit(SET_SUCCESS_OPERATION_MESSAGE, 'Test card initiated successfully!');
      await dispatch(types.LOAD_AMOUNT_OF_RUNNING_PROJECTS);
    } catch (e) {
      console.error(`${e}`);
      throw e;
    }
  },

  async [types.CALCULATE_LAST_SCAN_DATA]({ commit }, payload) {
    try {
      if (payload?.initiatedByFilterApply) {
        commit(SET_DATA_LOADING, true);
      }
      await calculateLastScanData({ domain: payload.domain, timeRange: payload.timeRange });
    } catch (e) {
      console.log(e);
    } finally {
      commit(SET_DATA_LOADING, false);
    }
  },

  async [types.LOAD_PANORAMIC_DATA]({ commit }, payload) {
    try {
      const panoramicData = await loadPanoramicData({ domain: payload.domain });
      commit(SET_PANORAMIC_DATA, panoramicData);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.GET_PORTS_TO_SCORE]({ commit }, payload) {
    try {
      const portsToScoreMap = await getPortsToScore({color: payload.color});
      commit(SET_PORTS_TO_SCORE, portsToScoreMap);
    } catch (e) {
      commit(CLEAR_PORTS_TO_SCORE);
      console.log(e);
    }
  },
  async [types.DELETE_TEST_CARD]({ commit, dispatch }, payload) {
    try {
      commit(SET_SUCCESS_OPERATION_MESSAGE, '');
      await removeTestCard(payload);
      commit(CLEAR_TEST_CARDS);
      const testCards = await loadTestCards();
      commit(SET_TEST_CARDS, testCards);
      dispatch(types.LOAD_TEST_CARDS);
      commit(SET_SUCCESS_OPERATION_MESSAGE, 'Test card deleted successfully!');
    } catch (e) {
      console.log(e);
    }
  },
  async [types.LOAD_TEST_CARDS_PASSWORD_SPRAY]({ commit }) {
    const testCardsPasswordSpray = await loadTestCards('passwordSpray');
    delete testCardsPasswordSpray.lastScannedObject;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in testCardsPasswordSpray) {
      testCardsPasswordSpray[key].sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
    }
    commit(SET_TEST_CARDS_PASSWORD_SPRAY, testCardsPasswordSpray);
  },
  async [types.LOAD_TEST_CARDS_DOMAINS]({ commit }, payload) {
    const testCardsDomains = await loadTestCards('domains', payload);
    const { lastScannedObject } = testCardsDomains;
    commit(SET_TEST_CARDS_DOMAINS_LAST_SCANNED_DATE, lastScannedObject);
    delete testCardsDomains.lastScannedObject;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in testCardsDomains) {
      testCardsDomains[key].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }
    commit(SET_TEST_CARDS_DOMAINS, testCardsDomains);
    const hasDiscoveryFinished = {};
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    Object.keys(testCardsDomains).forEach(tld => {
      for (let i = 0; i < testCardsDomains[tld].length; i += 1) {
        const testCard = testCardsDomains[tld][i];
        if (testCard.type === TEST_TYPES_TLDS.discovery && testCard.project.progress === 100 && testCard.project.status === projectStatuses.FINISHED) {
          hasDiscoveryFinished[tld] = {
            hasDiscoveryFinished: true,
          };
          break;
        }
      }
    });
    commit(SET_HAS_DISCOVERY_FINISHED, hasDiscoveryFinished);
  },
  async [types.LOAD_TEST_CARDS_HOSTS]({ commit }, payload) {
    const testCardsHosts = await loadTestCards('hosts', payload);
    delete testCardsHosts.lastScannedObject;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in testCardsHosts) {
      testCardsHosts[key].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }
    commit(SET_TEST_CARDS_HOSTS, testCardsHosts);
  },
  // eslint-disable-next-line no-empty-pattern
  async [types.STOP_SCAN]({ }, payload) {
    try {
      await stopScan(payload.projectId);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async [types.RETRY_SCAN]({ commit, dispatch }, payload) {
    try {
      commit(SET_SUCCESS_OPERATION_MESSAGE, '');
      await retryScan(payload.projectId);
      dispatch(types.LOAD_TEST_CARDS);
      commit(SET_SUCCESS_OPERATION_MESSAGE, 'Scan retried successfully!');
      await dispatch(types.LOAD_AMOUNT_OF_RUNNING_PROJECTS);
    } catch (e) {
      console.error(`${e}`);
      throw e;
    }
  },
  async [types.LOAD_TEST_CARDS_SUBDOMAINS]({ commit }, payload) {
    const testCardsSubdomains = await loadTestCards('subdomains', payload);
    delete testCardsSubdomains.lastScannedObject;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in testCardsSubdomains) {
      testCardsSubdomains[key].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }
    commit(SET_TEST_CARDS_SUBDOMAINS, testCardsSubdomains);
  },
  async [types.LOAD_TEST_CARDS_CLOUD_ACCOUNTS]({ commit }) {
    const testCardsCloudAccounts = await loadTestCards('cloudAccounts');
    delete testCardsCloudAccounts.lastScannedObject;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in testCardsCloudAccounts) {
      testCardsCloudAccounts[key].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }
    commit(SET_TEST_CARDS_CLOUD_ACCOUNTS, testCardsCloudAccounts);
  },
  async [types.ADD_NEW_TEST_PROJECT]({ commit, dispatch }, payload) {
    try {
      commit(SET_SUCCESS_OPERATION_MESSAGE, '');
      const createdTest = await addNewTestProject(payload);
      commit(SET_SUCCESS_OPERATION_MESSAGE, 'Test card added successfully!');
      await dispatch(types.LOAD_AMOUNT_OF_RUNNING_PROJECTS);
      return createdTest;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async [types.LOAD_PROJECTS]({ commit, getters }, payload) {
    let results;
    try {
      await commit(SET_PROJECTS_RUNNING_INTERVAL, true);
      if (payload?.initiatedByFilterApply) {
        if (!payload?.refId) {
          await commit(CLEAR_PROJECTS_PROGRESS);
        }
        await commit(SET_PROJECT_LIST_LOADING, true);
      }
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        results = await loadProjectsForSP(getters.projectListOptions);
      } else {
        results = await loadProjects({
          search: payload.search || '',
          page: payload.page || 1,
          limit: payload.limit || getters.paginationItemsPerPageByTabs.projects,
          sort: getters.projectListOptions.sort,
          refId: payload.refId,
        }, {
          domain: (payload?.domain || []),
        });
      }

      if (results) {
        if (results?.refId) {
          if (results.refId !== getters.projectsRefId) {
            if (!payload.repetitivePolling) {
              commit(CLEAR_PROJECTS);
            }
            commit(SET_PROJECTS_REF_ID, results.refId);
          }
          if (results?.progress) {
            commit(SET_PROJECTS_PROGRESS, results.progress);
          }
        } else {
          await commit(SET_PROJECTS_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_PROJECTS_REF_ID);
          commit(CLEAR_PROJECTS_PROGRESS);
          commit(SET_PROJECTS, results.items);
          const {
            page, pageCount, count, total,
          } = results;
          commit(SET_PROJECTS_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
        }
      }
      await commit(SET_PROJECTS_RUNNING_INTERVAL, false);
    } catch (e) {
      await commit(CLEAR_PROJECTS);
      await commit(CLEAR_PROJECTS_PAGINATION_STATE);
    } finally {
      if (!results?.refId) {
        await commit(SET_PROJECT_LIST_LOADING, false);
      }
    }
  },
  async [types.LOAD_TEST_TYPES]({ commit }) {
    try {
      const testTypesResponse = await loadTestTypes();
      commit(SET_TEST_TYPES, testTypesResponse);
    } catch (e) {
      commit(SET_TEST_TYPES, []);
      console.log(e);
    }
  },
  [types.CLEAR_TEST_CARDS]: createRunMutationAction(CLEAR_TEST_CARDS),
  [types.CLEAR_PROJECTS]: createRunMutationAction(CLEAR_PROJECTS),
  async [types.CHANGE_PROJECT_LIST_OPTIONS]({ commit }, options) {
    commit(SET_PROJECT_LIST_OPTIONS, { sort: options.sort });
  },
  async [types.LOAD_DETAILED_PROJECT]({ commit, getters }, id) {
    let projectsResponse;
    let project;
    try {
      commit(SET_DETAILED_PROJECT_LOADING, true);
      if (getters.auth['cognito:groups'].includes('SPWorker') || getters.auth['cognito:groups'].includes('SPFreelancer')) {
        projectsResponse = await loadDetailedProjectForSP(id);
      } else {
        projectsResponse = await loadDetailedProject(id);
      }
      project = projectsResponse;
      commit(SET_PROJECT, project);
    } catch (e) {
      commit(CLEAR_PROJECT);
    } finally {
      commit(SET_DETAILED_PROJECT_LOADING, false);
    }

    return project;
  },
  async [types.ADD_PROJECT]({ dispatch }, options) {
    await addNewProject(options.newProject);
    await dispatch(types.LOAD_PROJECTS);
  },
  async [types.UPDATE_SERVICE_PROVIDER]({ dispatch }, options) {
    await updateServiceProviderInfo(options.id, options.data);
    await dispatch(types.LOAD_PROJECTS);
  },
  async [types.CLEAR_DETAILED_PROJECT]({ commit }) {
    await commit(CLEAR_PROJECT);
  },

  async [types.UPDATE_PROJECT_STATUS]({ dispatch }, { projectId, status }) {
    const result = await updateProjectStatusBySP(projectId, status);
    dispatch(types.LOAD_PROJECTS);

    return result;
  },

  async [types.UPDATE_PROJECT_CREDENTIALS](store, { id, credentials }) {
    const updatedCredentials = await updateProjectCredentials(id, credentials);

    return updatedCredentials;
  },

  async [types.LOAD_WAF_MANUAL_CONFIGURATION](context, payload) {
    const wafManualConfiguration = await getWafManualConfiguration(payload);
    return wafManualConfiguration;
  },

};
